<template>
  <div class="index">
    <div class="index_d1">
      <el-carousel
        class="index_m_sw"
        :height="device === 'mobile' ? '200px' : '650px'"
      >
        <el-carousel-item v-for="(item, index) in banner" :key="index">
          <img class="index_m_img" :src="addImgUrl(item.Pic)" />
          <!-- <img class="index_m_img" src="./img/1.png" /> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="index_d2">
      <div class="indexd2_top">
        <div class="indexd2_title">
          <p>热门药方</p>
        </div>
        
      </div>
      <div class="indexd2_down">
        <img class="jt" src="./img/jt1.png" />
        <ul class="indexd2_d1">
          <li v-for="(item, index) in jdList" :key="index" >
            <a @click="toJdDetail(item.id,item.chinese_name)">{{ item.chinese_name }}</a>
          </li>
        </ul>
        <img class="jt" src="./img/jt2.png" />
      </div>
    </div>
    <div class="indexd3">
      <img src="./img/图层49.png" />
    </div>
    <div class="indexd4">
      <div class="indexd4_d1">
        <ul class="indexd4d1_p1">
          <a @click="toDetail(yslist[0].id)"><img class="yt" :src="addImgUrl(yslist[0].Pic)" /></a>
          <li>
            <p class="p3">
              {{ yslist[0].Intro }}
            </p>
          </li>
          <li>
            <p class="p2">{{ yslist[0].TypeName }}</p>
          </li>
          <li>
            <p class="p1">{{ yslist[0].Title }}</p>
          </li>
          <a><img class="st" src="./img/组 1.png" /></a>
        </ul>
      </div>
      <div class="indexd4_d2">
        <ul class="indexd4d2_p1">
          <a><img class="rx" src="./img/组 22.png" /></a>
          <li>
            <p class="p1">{{ yslist[1].Title }}</p>
          </li>
          <li>
            <p class="p2">{{ yslist[1].TypeName }}</p>
          </li>
          <li>
            <p class="p3">
              {{ yslist[1].Intro }}
            </p>
          </li>
          <li>
            <a @click="toDetail(yslist[1].id)"><img class="yt2" :src="addImgUrl(yslist[1].Pic)" /></a>
          </li>
        </ul>
      </div>
      <div class="indexd4_d3">
        <ul class="indexd4d3_p1">
          <a><img class="fx" src="./img/图层55.png" /></a>
          <li><p class="p2">延缓衰老、健脾和胃</p></li>
          <li><p class="p1">牛大力黑豆汤</p></li>
        </ul>
        <ul class="indexd4d3_p2">
          <a><img class="fx" src="./img/图层56.png" /></a>
          <li><p class="p2">提神醒脑、恢复活力</p></li>
          <li><p class="p1">熬夜汤</p></li>
        </ul>
      </div>
    </div>
    <div class="indexd3">
      <img src="./img/图层49.png" />
    </div>
    <div class="indexd5">
      <div class="indexd5_top">
        <p>滋补药材</p>
      </div>
      <div class="indexd5_d1" >
        <div class="indexd5_d1_p1" v-for="(item, index) in productList" :key="index" @click="toZhiWuDetail(item.id)" >
          <p class="indexd5_d1_p1_p1">
            {{ item.DescInfo }}
          </p>
          <p class="indexd5_d1_p1_p2">{{ item.Name }}</p>
          <img class="indexd5_d1_p1_img" :src="addImgUrl(item.Pic)" />
        </div>
        
      </div>
    </div>
    <div class="indexd3">
      <img src="./img/图层49.png" />
    </div>
    <div class="indexd6">
      <div class="indexd6_top">
        <p>药典传承</p>
      </div>
      <div class="index6_d1">
        <div class="index6_d1_p1">
          <img @click="jianpage" class="jt2" src="./img/jt3.png" />
          <ul class="indexd6_d1">
            <li v-for="(item, index) in ydlist" :key="index">
              <a @click="toYdDetail(item.id)">{{ item.name }}</a>
            </li>
          </ul>
          <img @click="jiapage" class="jt2" src="./img/jt4.png" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { addImgUrl } from "@/utils";
import { toLogin } from "@/utils";
export default {
  components: {},
  data() {
  
    return {
      banner: [],
      yslist: [],
      jdList: [],
      productList:[],
      ydlist:[],
      page:0,
    };
  },
  computed: {
    ...mapGetters(["userId","device", "homeClassifyShow"]),
  },
  watch: {},
  created: function () {
    this.getBanner();
    this.GetJDList();
    this.GetYSindexProduct();
    this.GetProductList();
    this.GetBotanicalDrugsList();
  },
  mounted: function () {},
  methods: {
    addImgUrl,
    async getBanner() {
      let res = await this.$post("GetBanner", {
        BannerType: 1,
      });
      // console.log(res);
      this.banner = res.data.ResultData;
    },
    toJdDetail(id,jdname) {
      if (this.userId == "") {
          toLogin(this)
          this.$message.error("请先登录后查看");
       } else {
        this.$router.push({
          path: "/prescriptionDetail",
          query: {
            id: id,
            jdname:jdname,
          },
        });
      }
    },
    toYdDetail(id) {
      this.$router.push({
        path: "/chemicalsDetail",
        query: {
          id: id,
        },
      });
    },
    toDetail(id){
        this.$router.push({
         path: "/ncpgoodsdetail",
          query: {
          id: id,
          },
        });
    },
    toZhiWuDetail(id) {
				this.$router.push({
					path: '/goodsDetail',
					query: {
						id: id
					}
				});
			},
    jiapage(){
      this.page++;
      this.GetBotanicalDrugsList();
    },
    jianpage(){
      this.page--;
      this.GetBotanicalDrugsList();
    },
    async GetYSindexProduct() {
      let res = await this.$post("GetYSindexProduct", {
        page: this.page,
      });
      console.log(res,'GetYSindexProduct');
      this.yslist = res.data.ResultData;
    },
    async GetProductList() {
      let res = await this.$post("GetProductList", {pageSize:4});
      console.log(res,'GetProductList');
      this.productList = res.data.ResultData;
      this.productList.forEach((product) => {
        product.DescInfo = this.decodeHTML(product.DescInfo);
        function stripHTML(htmlString) {
            const regex = /(<([^>]+)>)/ig;
            return htmlString.replace(regex, "");
        }
        product.DescInfo =  stripHTML(this.decodeHTML(product.DescInfo)).replace(/\s+/g, ' ').trim();
        // console.log(product.DescInfo,'DescInfo');
        product.Pic = product.Pic.split(',')[0];
        // console.log(product.Pic,'Pic');
      });
    },
    decodeHTML(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    async GetJDList() {
      let res = await this.$post("GetIndexJDList", {});
      console.log(res,'GetJDList');
      this.jdList = res.data.ResultData;
    },
    async GetBotanicalDrugsList() {
      let res = await this.$post("GetBotanicalDrugsList", {
        pageSize: 9,
        page:this.page,
      });
      console.log(res,'Ydlist');
      this.ydlist = res.data.ResultData;
    },
  },
};
</script>


<style scoped >
.index {
  width: 100%;
  background-image: url("./img/组1.png");
  background-size: 100% 100%;
  background-position: center;
  margin-top: -3px;
}

.index_d1 {
  width: 100%;
}

.index_m_img {
  width: 100%;
  height: 650px;
  cursor: pointer;
}

.index_d2 {
  width: 100%;
}

.indexd2_top {
  position: relative;
  margin:  auto;
  margin-top: 100px;
  text-align: center;
  font-size: 56px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bold;
  color: white;
}
.indexd2_title{
  background-image: url("./img/图层44.png");
  background-size: 100% 100%;
  height: 200px;
  width: 830px;
  margin:  auto;
}
.indexd2_top p {
  line-height:180px;
  text-align: center;
  letter-spacing: 40px;
  margin-left: 80px;
}

.indexd2_down {
  margin-top: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.jt {
  height: 60px;
  margin-top: 60px;
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100vh);
  }
}
.indexd2_d1 {
  width: 56%;
  display: flex; 
  list-style: none; 
  padding: 0; 
  overflow: hidden;
}
.indexd2_d1 li {
  writing-mode: vertical-rl; 
  text-orientation: mixed;
  text-decoration: underline;
  font-family: "SimSun", "STSong", serif; 
  letter-spacing: 20px;
  padding: 10px;
  font-weight: bold;
  font-size: 28px;
  position: relative;
  animation: scroll 20s linear infinite;
}
.indexd2_d1 a img {
  margin-top: 40px; 
}

.indexd3 {
  width: 100%;
  margin-top: 50px;
}
.indexd3 img {
  width: 100%;
}
.indexd4 {
  margin-top: 50px;
}
.indexd4_d1 {
  width: 100%;
}
.indexd4d1_p1 {
  width: 100%;
  margin: auto;
  display: flex; 
  justify-content: center; 
  list-style: none; 
}
.indexd4d2_p1 {
  display: flex; 
  list-style: none; 
  padding: 0; 
  margin: 0px auto ;
}
.indexd4_d2 {
  display: flex; 
  padding: 0;
  margin: 0px auto ;
}
.indexd4_d3 {
  display: flex;
  margin-top: 100px;
  justify-content: center;
}
.indexd4d3_p1 {
  display: flex; 
  justify-content: center; 
  list-style: none; 
  padding: 0; 
}
.indexd4d3_p2 {
  display: flex;
  justify-content: center;
  list-style: none; 
  padding: 0; 
  margin-left: 150px;
}
.indexd4d2_p1 li {
  margin-top: 50px;
}
.yt {
  height: 250px;
  margin: 30px 0 0;
  border-radius: 50%;
  margin-left: 300px;
}
.st {
  height: 370px;
}
.rx {
  margin-top: 30px;
  height: 230px;
}
.fx {
  height: 180px;
  margin-right: 50px;
}
.yt2 {
  height: 250px;
  border-radius: 50%;
  margin-left: 80px;
  margin-top: 30px;
}

.p3 {
  height: 400px;
  margin: 0px 20px 0px 20px;
  writing-mode: vertical-rl;
  text-orientation: mixed; 
  font-family: "SimSun", "STSong", serif; 
  letter-spacing: 5px;       
  letter-spacing: 3px;
  line-height: 1.5;
  font-weight: bold;
  font-size: 24px;
  color: #38100e;
}
.p2 {
  writing-mode: vertical-rl;
  text-orientation: mixed; 
  font-family: "SimSun", "STSong", serif; 
  letter-spacing: 3px;
  font-weight: bolder;
  font-size: 22px;
  color: white;
  background-color: #ba2425;
  border-radius: 10px; 
  padding: 10px;
}
.p1 {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: "SimSun", "STSong", serif; 
  letter-spacing: 5px;         
  font-weight: 900;
  font-size: 32px;
  margin: 0 20px 0;
}
.indexd5_top {
  margin: 0 auto;
  width: 400px;
  height: 150px;
  margin-top: 100px;
  margin-bottom: 100px;
  background-image: url("./img/图层57.png");
  background-size: 100%;
  background-position: center;
  text-align: center;
  line-height: 150px;
  font-size: 48px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bolder;
  color: white;
}
.indexd5_d1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.indexd5_d1_p1 {
  height: 510px;
  width:800px;
  background-image: url("./img/包图网_18243549中国风复古金色边框.png");
  background-position: center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}
.indexd5_d1_p1_p1 {
  width: 50%;
  height: 50%;
  line-height: 1.2;
  writing-mode: vertical-rl;
  text-orientation: mixed; 
  font-family: "SimSun", "STSong", serif;
  font-weight: bold;
  color: #38100e;
  font-size: 17px;
  overflow:hidden;
  margin-left: 40px;
}
.indexd5_d1_p1_p2 {
  height: 50%;
  margin: 0 25px;
  font-size: 28px;
  font-weight: bolder;
  writing-mode: vertical-rl;
  text-orientation: mixed; 
  font-family: "SimSun", "STSong", serif;
}
.indexd5_d1_p1_img {
  height: 224px;
  width: 224px;
  border-radius: 50%;
}

.indexd6_top {
  margin: 0 auto;
  width: 440px;
  height: 100px;
  margin-top: 100px;
  margin-bottom: 60px;
  background-image: url("./img/图层6.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 100px;
  font-size: 48px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bolder;
  color: white;
}
.index6_d1_p1{
  width: 100%;
  display: flex;
  justify-content: center;
}
.indexd6_d1 {
  display: flex; /* 使用弹性盒子布局 */
  /* 如果希望列表项水平排列，可以添加以下属性 */
  list-style: none; /* 去除默认的列表项样式 */
  padding: 0; /* 去除默认的内边距 */
  overflow: hidden;
}
.indexd6_d1 li {
  height: 450px;
  background-image: url("./img/图层6-1.png");
  background-size: 100% 100%;
  writing-mode: vertical-rl; /* 将文字竖向排列 */
  text-orientation: mixed; /* 用于兼容不同浏览器 */
  font-family: "SimSun", "STSong", serif; /*设置字体 */
  letter-spacing: 10px; /**设置间距 */
  padding: 10px 42px;
  margin: 30px 20px;
  font-weight: bolder;
  font-size: 32px;
  position: relative;
}
.indexd6_d1 li a{
  margin-top: 40px;
}
.jt2{
  height: 90px;
  margin-top: 225px;
}
.indexd6{
  padding-bottom: 30px;
}



</style>

<style lang="scss" scoped src="./mobile.scss" ></style>